import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyBusinessPrioritiesChanges } from '../../api'
import { mapBusinessPriorityToApi, toggleMarketStatus } from '../../lib'
import { selectBusinessPrioritiesUserInfo } from '../selectors'
import { IBusinessPriority } from '../types'

export const requestBusinessPrioritiesChangeStatus = createAsyncThunk(
  'businessPriorities/changeStatus',
  (record: IBusinessPriority, { getState }) => {
    const fYear = selectJBPSettingsCurrentFYear(getState())
    const userMarket = selectBusinessPrioritiesUserInfo(getState())?.market || ''
    const newMarkets = toggleMarketStatus(record.markets, userMarket)

    const payload = mapBusinessPriorityToApi(
      {
        ...record,
        markets: newMarkets,
      },
      fYear
    )

    return applyBusinessPrioritiesChanges(payload)
  }
)
